import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-duplicate-title',
    templateUrl: './duplicate-title.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoDuplicateTitleComponent {
}
